import { downloadInvoice } from '../api/InvoicesAPI';
export async function downloadInvoicePDF(objectId, onFailure) {
  await downloadInvoice(objectId).then(response => window.location.href = response.url).catch(error => {
    if (error.status === 404) {
      onFailure();
    } else {
      throw error;
    }
  });
}